// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"markdown-styles_reactMarkDown__RZYus"};